export default __webpack_public_path__ + "static/media/payroll-glyph-16-px.ad316c65.svg";